import { TemplateForm, TemplateFormField } from '../interfaces/template-form';

export const getTemplateFormFields = (form: TemplateForm) =>
  form.template.reduce(
    (acc, curr) => {
      curr.fields.forEach((field: TemplateFormField) => {
        acc[field.props.name] = field;
      });
      return acc;
    },
    {} as { [key: string]: TemplateFormField }
  );
